import React, {useContext, useEffect, useState} from 'react';

import {Input, Icon} from 'components';
import * as utils from 'utils';

import styles from './Search.module.scss';

import Context from '../../../../context';
import {reducerFilters} from '../../../../reducers';

export const Search = () => {
  const {
    loading,
    filters: {search},
    dispatchFilters,
  } = useContext(Context);

  const [value, setValue] = useState(search[0].label);

  const handlePressEnter = values => {
    // Tracking Analytics
    utils.handleAnalytics('groupSearch', values);

    dispatchFilters({
      type: reducerFilters.actionTypes.updateSearch,
      payload: [{value: 'search--filter', label: values}],
    });
  };

  const handleBlur = () => setValue(search[0].label);

  useEffect(() => {
    setValue(search[0].label);
  }, [search]);

  return (
    <Input
      className={styles.wrap}
      value={value}
      disabled={loading}
      placeholder="Search"
      suffix={<Icon type="search" />}
      onChange={setValue}
      onPressEnter={handlePressEnter}
      onBlur={handleBlur}
    />
  );
};
